<template>
  <div class="AARR">
    <!-- 顶部区域 -->
    <div class="f1">
      <div class="d1">全渠道用户画像，360度洞悉顾客行为</div>
      <div class="d2">
        <div class="text">
          <!-- <img src="../../assets/images/newIcon/popupwindow_background.png" alt=""> -->
          我们提供新增会员、活跃会员、留存会员、会员参与度四种分析方法，点击可查看不同界面的详细数据
        </div>
        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="" />
      </div>
    </div>
    <!-- 4个按钮区域 -->
    <el-radio-group v-model="tabPosition" style="margin-top: 20px" class="ft">
      <el-radio-button label="1">新增分析</el-radio-button>
      <el-radio-button label="2">活跃分析</el-radio-button>
      <el-radio-button label="3">留存分析</el-radio-button>
      <el-radio-button label="4">访问分析</el-radio-button>
    </el-radio-group>
    <div class="fr">
            <p>
              <img
                src="../../assets/images/newIcon/ss_shaixuan_icon.png"
                alt=""
              />
              <el-select
                style="width: 100px"
                v-model="value1"
                placeholder="业务系统"
                class="my-select"
              >
                <el-option
                  v-for="item in options1"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </p>
          </div>
    <AARRadd v-if="tabPosition == 1"></AARRadd>
    <AARRactive v-if="tabPosition == 2"></AARRactive>
    <AARRkeep v-if="tabPosition == 3"></AARRkeep>
    <AARRvisit v-if="tabPosition == 4"></AARRvisit>
  </div>
</template>
<script>
import AARRadd from "./components/AARRadd.vue";
import AARRactive from "./components/AARRactive.vue";
import AARRkeep from "./components/AARRkeep.vue";
import AARRvisit from "./components/AARRvisit.vue";
export default {
  components: {
    AARRadd,
    AARRactive,
    AARRkeep,
    AARRvisit,
  },
  data() {
    return {
      value1:'业务系统',
      options1: [{ name: "小橘帮帮" },{ name: "颐安中台" }],
      tabPosition: "1",
    };
  },
};
</script>
<style lang="less">
.AARR {
  //顶部区域
  padding: 20px;
  .f1 {
    display: flex;
    justify-content: space-between;
    .d1 {
      height: 106px;
      box-sizing: border-box;
      padding-right: 6%;
      padding-left: 4%;
      padding-top: 30px;
      width: 65%;
      background: url("../../assets/images/newIcon/jijmu_title_bg.png")
        no-repeat;
      background-size: 100% 100%;
      font-size: 21px;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      letter-spacing: 7px;
    }
    .d2 {
      width: 34%;
      display: flex;
      align-items: center;
      height: 106px;
      .text {
        display: flex;
        align-items: center;

        padding: 4px 30px;
        // background: #fff;
        height: 100%;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        img {
          width: 305px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #327eff;
        }
        background: url("../../assets/images/newIcon/popupwindow_background.png")
          no-repeat;
        background-size: 100% 100%;
      }

      img {
        width: 58px;
        height: 58px;
      }
    }
  }
  //4个按钮区域
  //两个按钮
  .ft {
    .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 18px 0 0 18px;
      width: 81px;
    }
    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 18px 18px 0;
      width: 81px;
    }
  }
     .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          margin-top: 20px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
}
</style>